export default __webpack_public_path__ + "static/media/vaasstarterbronze.085738d3.svg";